// src/redux/actions/salesActions.js
import {
    UPDATE_DISCLAIMER_STATUS_REQUEST,
    UPDATE_DISCLAIMER_STATUS_SUCCESS,
    UPDATE_DISCLAIMER_STATUS_FAILURE,
} from '../../../../Constants/actionTypes';
import { updateDisclaimerStatus } from '../../../../Constants/apiService'


// Fetch Sales Request Action
export const updateDisclaimerStatusRequest = () => ({
    type: UPDATE_DISCLAIMER_STATUS_REQUEST,
});

// Fetch Sales Success Action
export const updateDisclaimerStatusSuccess = (salesData) => ({
    type: UPDATE_DISCLAIMER_STATUS_SUCCESS,
    payload: salesData,

});

// Fetch Sales Failure Action
export const updateDisclaimerStatusFailure = (error) => ({
    type: UPDATE_DISCLAIMER_STATUS_FAILURE,
    payload: error,
});



// Thunk Action Creator for Fetching Sales
export const updateDisclaimerStatusAct = (params) => {
    console.log(params);
    return async (dispatch, getState) => {
      dispatch(updateDisclaimerStatusRequest());
  
      const state = getState();
      const accessToken = state.auth.accessToken;
  
      try {
        const data = await updateDisclaimerStatus(accessToken, params);
        console.log(data);
  
        dispatch(updateDisclaimerStatusSuccess(data));
        return data; // Return the API response
      } catch (error) {
        let errorMessage;
        if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
          errorMessage = 'Server is currently down. Please try again later.';
        } else {
          errorMessage = error.message;
        }
        dispatch(updateDisclaimerStatusFailure(errorMessage));
        throw new Error(errorMessage); // Throw the error to propagate it
      }
    };
  };
  





